import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

function Codes() {
    return(
        <div>
            <CssBaseline />
        </div>
    )
};
export default Codes;